import classNames from "classnames";
import { useContext, useLayoutEffect, useRef, useState } from "react";
import ReactPlayer from "react-player/lazy";
import { useWindowSize } from "react-use";
import { Card, ContentContainer, heightStyles, positionStyles, widthStyles } from "ui";
import { BlocksContext } from "../../BlocksContext";
import { Editor } from "./Editor";

interface VideoBlockProps {
  blockId: string;
  videoUrl: string;
  updateBlock: (props: { videoUrl: string }) => void;
}

export function VideoBlock({ blockId: _blockId, videoUrl, updateBlock }: VideoBlockProps) {
  const { EditPopover } = useContext(BlocksContext);
  const [isEditorOpen, setIsEditorOpen] = useState(!videoUrl);
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number>(0);
  const [height, setHeight] = useState<number>(0);
  const { width: windowWidth } = useWindowSize();

  useLayoutEffect(() => {
    if (ref?.current?.offsetWidth && windowWidth) {
      setWidth(ref.current.offsetWidth - 2);
      setHeight((width * 9) / 16);
    }
  }, [width, windowWidth]);

  const playerWidth = width > 0 ? `${width}px` : "100%";

  const handleUrlChange = (newUrl: string) => {
    updateBlock({ videoUrl: newUrl });
    setIsEditorOpen(false);
  };

  return (
    <div className={positionStyles.relative}>
      <EditPopover
        isOpen={isEditorOpen}
        onOpen={() => setIsEditorOpen(true)}
        showEditButton={!!videoUrl}
        editor={<Editor onClose={() => setIsEditorOpen(false)} videoUrl={videoUrl} onChangeUrl={handleUrlChange} />}
      />
      {videoUrl ? (
        <Card className={classNames(widthStyles.full, heightStyles.min200)} ref={ref}>
          <ReactPlayer
            style={{ borderRadius: "0.25rem", overflow: "hidden" }}
            url={videoUrl}
            controls
            height={height}
            width={playerWidth}
          />
        </Card>
      ) : (
        <ContentContainer
          onClick={() => setIsEditorOpen(true)}
          iconType="Video"
          label="Add a video"
          className={widthStyles.full}
        />
      )}
    </div>
  );
}
